import { FC, useEffect, useState } from 'react';
import { IFilterProps } from '.';
import { Button } from 'src/Components';
import {
	TableColumnEnumType,
	RelationFieldType,
} from 'src/Components/DataGrid';
import Select from './Select';
import API from 'src/API';
import st from './DefFilterCommon.module.scss';

/** Компонента-обертка Relation-фильтра для подготовки данных для выпадающего списка */
const Relation: FC<IFilterProps> = (props) => {
	const {
		columnId,
		isShowModal,
		columnType,
		value,
		setValue,
		cancelHandler,
		applyValueHandler,
	} = props;

	const relation = columnType.relation;
	if (!relation) {
		throw new Error(``);
	}

	const [isWait, setIsWait] = useState<boolean>(false);
	const [options, setOptions] = useState<any[]>([]);

	useEffect(() => {
		loadOptions('');
	}, []);

	const onServerSideSearchHandler = (search: string) => {
		loadOptions(search);
	};

	const loadOptions = (searchTerm: string) => {
		setIsWait(true);
		const adddata = relation.onPrepareRequestData
			? relation.onPrepareRequestData()
			: null;
		API.getFilterValues(
			relation?.method,
			relation.url,
			searchTerm ?? '',
			0,
			100,
			value,
			adddata,
		)
			.then((result) => {
				if (!result?.hasError) {
					const list = prepareEnumData(result, relation);
					setOptions(list);
				}
			})
			.catch((e: any) => {
				console.warn(e);
			})
			.finally(() => {
				return setIsWait(false);
			});
	};

	/** Подготовка списка выбранных значений */
	const prepareValue = () => {
		if (!value) {
			return [];
		} else if (Array.isArray(value)) {
			return value;
		} else {
			return [value];
		}
	};

	/** Рендер кнопок отмена/применить */
	const renderButtons = () => {
		if (!value || !value.length) {
			return null;
		}
		return (
			<div className={st.modalButtonsSB}>
				<Button
					id={'filter_cancel-' + columnId}
					onClick={cancelHandler}
					variant="red"
					outline
				>
					Отмена
				</Button>
				<Button
					id={'filter_apply-' + columnId}
					onClick={applyValueHandler}
				>
					Применить
				</Button>
			</div>
		);
	};

	return (
		<Select
			isShowModal={isShowModal}
			isWait={isWait}
			multiple={!!columnType.multiple}
			options={options}
			selectedIds={prepareValue()}
			setSelected={setValue}
			renderButtons={renderButtons}
			onServerSideSearch={onServerSideSearchHandler}
		/>
	);
};

const prepareEnumData = (
	data: any = [],
	relation: RelationFieldType,
): TableColumnEnumType[] => {
	return data.map((item: any) => {
		return {
			id: item[relation.valueKey],
			title: relation.titleKey
				? item[relation.titleKey]
				: item[relation.valueKey],
		};
	});
};

/** Возвращает текст опции */
const getTitle = (option: TableColumnEnumType): string => {
	return option.title ?? option.id;
};

export default Relation;
